module.exports = __webpack_public_path__ + "media/images/emblems/Ruemlang-blazon-7cf07dde861b20479b20f3993524553c.svg";